<script setup lang="ts">
    import { InputRow, SectionHeader, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import type { User } from '@/types';

    defineProps<{
        form: any;
        keepersEmployees: User[];
        loadingKeepersEmployees: boolean;
    }>();
</script>

<template>
    <div class="space-y-5">
        <SectionHeader>{{ $t('companies.information') }}</SectionHeader>
        <div class="grid gap-3 sm:grid-cols-2">
            <InputRow
                :form="form"
                name="name"
                label="companies.form.name"
            >
                <Input
                    id="name"
                    v-model="form.name"
                    autocomplete="name"
                    :placeholder="$t('companies.form.name')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="cvr"
                label="companies.form.cvr"
            >
                <Input
                    id="cvr"
                    v-model="form.cvr"
                    autocomplete="name"
                    :placeholder="$t('companies.form.cvr')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="address"
                label="companies.form.address"
            >
                <Input
                    id="address"
                    v-model="form.address"
                    autocomplete="address"
                    :placeholder="$t('companies.form.address')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="postal_code"
                label="companies.form.postal_code"
            >
                <Input
                    id="postal_code"
                    v-model="form.postal_code"
                    autocomplete="postal_code"
                    :placeholder="$t('companies.form.postal_code')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="city"
                label="companies.form.city"
            >
                <Input
                    id="city"
                    v-model="form.city"
                    autocomplete="city"
                    :placeholder="$t('companies.form.city')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="country"
                label="companies.form.country"
            >
                <Input
                    id="country"
                    v-model="form.country"
                    autocomplete="country"
                    :placeholder="$t('companies.form.country')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="email"
                label="companies.form.email"
            >
                <Input
                    id="email"
                    v-model="form.email"
                    autocomplete="email"
                    :placeholder="$t('companies.form.email')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="telephone"
                label="companies.form.telephone"
            >
                <Input
                    id="telephone"
                    v-model="form.telephone"
                    autocomplete="name"
                    :placeholder="$t('companies.form.telephone')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="mobile_number"
                label="companies.form.mobile_number"
            >
                <Input
                    id="mobile_number"
                    v-model="form.mobile_number"
                    autocomplete="name"
                    :placeholder="$t('companies.form.mobile_number')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="fax_number"
                label="companies.form.fax_number"
            >
                <Input
                    id="fax_number"
                    v-model="form.fax_number"
                    autocomplete="name"
                    :placeholder="$t('companies.form.fax_number')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="roger_invoices"
                label="companies.form.roger_invoices"
                >
                <Input
                id="roger_invoices"
                v-model="form.roger_invoices"
                autocomplete="name"
                :placeholder="$t('companies.form.roger_invoices')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="roger_receipts"
                label="companies.form.roger_receipts"
                >
                <Input
                id="roger_receipts"
                v-model="form.roger_receipts"
                autocomplete="name"
                :placeholder="$t('companies.form.roger_receipts')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="keepers_email"
                label="companies.form.keepers_email"
            >
                <Input
                    id="keepers_email"
                    v-model="form.keepers_email"
                    autocomplete="name"
                    :placeholder="$t('companies.form.keepers_email')"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="employee_default_id"
                label="companies.form.primary_employee"
            >
                <Combobox
                    v-model="form.employee_default_id"
                    :options="keepersEmployees"
                    :placeholder="$t('companies.form.primary_employee')"
                    :loading="loadingKeepersEmployees"
                    label-by="name"
                    value-by="id"
                />
            </InputRow>
            <InputRow
                :form="form"
                name="assistant_id"
                label="companies.form.assistant_id"
            >
                <Combobox
                    v-model="form.assistant_id"
                    :options="keepersEmployees"
                    :placeholder="$t('companies.form.assistant_id')"
                    :loading="loadingKeepersEmployees"
                    label-by="name"
                    value-by="id"
                />
            </InputRow>
        </div>
    </div>
</template>
